import { FaTimesCircle, FaCheckCircle, FaMoneyBillWave, FaUndo } from 'react-icons/fa'; // example icons
import TinyBadge from '../../components/badge/TinyBadge';

export const paymentStatusMapping = {
  UNPAID: {
    label: 'Nieopłacona',
    color: 'danger',
    bg: 'light-danger',
    icon: <FaTimesCircle />,
  },
  ON_BOOKING_PAID: {
    label: 'Zapłacono przy rezerwacji',
    color: 'primary',
    icon: <FaMoneyBillWave />,
  },
  PARTIALLY_PAID: {
    label: 'Częściowo opłacona',
    color: 'warning',
    icon: <FaMoneyBillWave />,
  },
  PAID_WITHOUT_DEPOSIT: {
    label: 'Opłacona bez kaucji',
    color: 'warning',
    icon: <FaCheckCircle />,
  },
  PAID: {
    label: 'Opłacona',
    color: 'success',
    icon: <FaCheckCircle />,
  },

  TO_REFUND: {
    label: 'Do zwrotu',
    color: 'warning',
    icon: <FaUndo />,
  },
  REFUNDED: {
    label: 'Zwrocono',
    color: 'success',
    icon: <FaUndo />,
  },
  CANCELED: {
    label: 'Anulowana',
    color: 'secondary',
    icon: <FaTimesCircle />,
  },
};

export const renderPaymentStatus = (status, className = '', disableTopMargin = false, icon = false) => {
  const defaultClassName = disableTopMargin ? '' : 'mt-2';
  const statusInfo = paymentStatusMapping[status];

  return statusInfo ? (
    <TinyBadge
      text={statusInfo.label}
      color={statusInfo.color}
      bg={statusInfo.bg}
      icon={icon && statusInfo.icon}
      onlyIcon={icon}
      className={`${defaultClassName} ${className}`}
    />
  ) : (
    'Niewiadomy status'
  );
};

